import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import type { SingleValueProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { Segment } from '@feathr/blackbox';
import { Label } from '@feathr/components';

import SegmentAudienceChips from '../SegmentAudienceChips';
import SegmentDataChip from '../SegmentDataChip';
import type { ISegmentSelectStatProps } from '../SegmentOption';

import * as styles from './SegmentSingleValue.css';

type TSingleValueProps = SingleValueProps<Segment>;

function SegmentSingleValue(props: TSingleValueProps): JSX.Element {
  const { data } = props;
  // isLoading/isDisabled are standard react-select selectProps; emailCampaign and stat are our custom props.
  const { isLoading, isDisabled } = props.selectProps;
  const { emailCampaign, stat } = props.selectProps as typeof props.selectProps &
    ISegmentSelectStatProps;

  const testId = `${data.id}-${stat}`;

  return (
    <components.SingleValue {...props}>
      <Observer>
        {(): JSX.Element => (
          <Label className={styles.label} disabled={isDisabled} weight={'normal'}>
            {data.name}
          </Label>
        )}
      </Observer>

      {/* If the options are loading, don't show the data chips so the loading ellipsis can be displayed. Otherwise, the chips shift abruptly on load. */}
      {data instanceof Segment && !isLoading && (
        <div className={styles.data}>
          {emailCampaign ? (
            <SegmentAudienceChips campaign={emailCampaign} segment={data} />
          ) : (
            <>
              <SegmentDataChip
                name={`${data.id}-num_users_total`}
                statType={'num_users_total'}
                statValue={data.get('stats_cache')?.num_users_total || 0}
              />
              {!!stat && (
                <SegmentDataChip
                  name={testId}
                  statType={stat}
                  statValue={data.get('stats_cache')?.[stat] || 0}
                />
              )}
            </>
          )}
        </div>
      )}
    </components.SingleValue>
  );
}

export default SegmentSingleValue;
